/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_DarkInputs */

const en_directory_submit_badge_dark = /** @type {(inputs: Directory_Submit_Badge_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark`)
};

const zh_directory_submit_badge_dark = /** @type {(inputs: Directory_Submit_Badge_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`深色`)
};

/**
* | output |
* | --- |
* | "Dark" |
*
* @param {Directory_Submit_Badge_DarkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_dark = /** @type {((inputs?: Directory_Submit_Badge_DarkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_DarkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_dark(inputs)
	return zh_directory_submit_badge_dark(inputs)
});
export { directory_submit_badge_dark as "directory.submit.badge_dark" }